<template>
      
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            
            
            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                              
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">考试专区</h4>
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                      <li class="breadcrumb-item"><a href="#">考试专区</a></li>
                                                      <li class="breadcrumb-item active">考试报名</li>
                                                </ol>
                                                
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->
                              
                              
                              <div class="row">
                                    <div class="col-md-6" style="width:100%;max-width:100%;flex:auto;">
                                          <div class="card-box">
                                                <h4 class="header-title m-t-0 m-b-30">请确认个人信息</h4>
                                               
                                                <div class="tab-content">
                                                      <div class="tab-pane fade show active" id="home">
                                                            <!--start-->
                                                            
                                                            
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*姓（中文）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="surname" readonly="readonly"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*名（中文）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="name" readonly="readonly"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*姓（拼音）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="surname_en" readonly="readonly"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*名（拼音）</p>
                                                                  <input type="text" name="country"
                                                                         v-model="name_en" readonly="readonly"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">性别</p>
                                                                  <input type="text" name="country"
                                                                         v-model="sex"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">手机号</p>
                                                                  <input type="text" name="country"
                                                                         v-model="tel"
                                                                         class="form-control">
                                                            </div>
                                                            <div class="inputself">
                                                                  <p class="mb-1 mt-4 font-weight-bold">*邮箱</p>
                                                                  <input type="text" name="country"
                                                                         v-model="email"
                                                                         class="form-control">
                                                            </div>
                                                            
                                                           <div style="width: 100%;float: left;">
                                                            <button type="submit" style="margin:3rem;background-color: #5d6dc3;border:1px;border-color:#5d6dc3;padding:10px;border-radius: 5px;color:#ffffff"  v-on:click="edit">下一步</button>
                                                           </div>
                                                            
                                                            <!--over-->
                                                      </div>
                                                
                                                </div>
                                          </div>
                                    </div> <!-- end col -->
                                    
                                    <!-- end col -->
                              </div>
                              <!-- end row -->
                        
                        
                        
                        
                        
                        </div> <!-- container -->
                  
                  </div> <!-- content -->
      
                  <!--footer-->
            
            </div>
            
            
            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->
      
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'main',
            components:{topbar,left},
            data() {
                  return {
                        tel: this.tel,
                        email:this.email,
                        lisname:this.lisname,

                        surname: this.surname,
                        name: this.name,
                        surname_en: this.surname_en,
                        name_en: this.name_en,
                        sex: this.sex,
                       
                        
                  }
            },
            mounted(){
                  this.showmember();
                  //this.m_list(); 系统消息
            },
            methods: {
                  showmember: function () {
                        //console.log(this.identity);
                        let data = {
                              tel: this.tel
                        }
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/member_show',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.tel=response.data.user.tel;
                              this.email=response.data.user.email;
                              this.lisname=response.data.user.name;

                              this.surname=response.data.information.surname;
                              this.name=response.data.information.name;
                              this.surname_en=response.data.information.surname_en;
                              this.name_en=response.data.information.name_en;
                              this.sex=response.data.information.sex;
                              

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  edit:function () {
                        let data = {
                              tel: this.tel,

                              surname: this.surname,
                              name: this.name,
                              surname_en: this.surname_en,
                              name_en: this.name_en,
                              sex: this.sex,
                            
                        }
                        this.$axios({
                              method: 'post',
                              url: '/api/member2/member_edit',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.data.code==0){
                                   
                                    this.$router.push({name:'signup_pay'});
                              }else{
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }
                              console.log(response.data.code);

                        }.bind(this)).catch(function OnError() {

                        })
                  },

                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}
      
      .msglist li{width:50%;float:left;
            line-height: 2rem;}
      .msglist{width:100%;float:left;}
      .msglistright{text-align: right;}
      
      .inputself{width:49%;margin-right:1%;float: left}


</style>



// WEBPACK FOOTER //
// src/components/signup_check.vue